<template>
    <div v-if="this.requires_delivery" class="card mb-4">
        <div class="card-header">
            <div class="row">
                <div class="col-6">
                    <h3 class="pull-left">
                        <strong>{{ trans.get('checkout.hotel_address') }}</strong>
                    </h3>
                </div>
                <div class="col-6">
                    <div class="text-right">
                        <i>
                        </i>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div id="hotel_address">
                <div class="row">
                    <div class="col-md-12 col-12">
                        <label for="hotel_address_name" class="form__label">
                            {{ trans.get('checkout.hotel_name')}} *
                        </label>
                        <div class="form__controls form__controls--default">
                            <input-error field="hotel_address.name"></input-error>
                            <input :disabled="loading" id="hotel_address_name" class="field" v-model="name">
                        </div><!-- /.form__controls -->
                    </div>
                    <div class="col-md-6 col-12">
                        <label for="hotel_address_street" class="form__label">
                            {{ trans.get('checkout.address') }} *
                        </label>
                        <div class="form__controls form__controls--default">
                            <input-error field="hotel_address.street"></input-error>
                            <input :disabled="loading" id="hotel_address_street" type="text" class="field" v-model="street">
                        </div><!-- /.form__controls -->
                    </div>
                    <div class="col-md-6 col-12">
                        <label for="hotel_address_country" class="form__label">
                            {{ trans.get('checkout.country') }} *
                        </label>
                        <div class="form__controls form__controls--default">
                            <div class="select">
                                <input-error field="hotel_address.country"></input-error>
                                <select :disabled="loading" v-model="country" id="hotel_address_country">
                                    <option v-for="(name, id) in this.countries" v-bind:value="id">
                                        {{ name }}
                                    </option>
                                </select>
                                <i class="ico-arrow">
                                    <svg width="18" height="11" viewBox="0 0 18 11" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1l8 8 8-8" stroke="#D2D2D2" stroke-width="1.651"
                                              fill="none" fill-rule="evenodd">
                                        </path>
                                    </svg>
                                </i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row margin-bottom-20">
                    <div class="col-md-6 col-12">
                        <label for="hotel_address_city" class="form__label">
                            {{ trans.get('checkout.city') }} *
                        </label>
                        <div class="form__controls form__controls--default">
                            <input-error field="hotel_address.city"></input-error>
                            <input :disabled="loading" id="hotel_address_city" type="text" class="field" v-model="city">
                        </div><!-- /.form__controls -->
                    </div>
                    <div class="col-md-6 col-12">
                        <label for="hotel_address_zip" class="form__label">
                            {{ trans.get('checkout.postcode') }}*
                        </label>
                        <div class="form__controls form__controls--default">
                            <input-error field="hotel_address.zip"></input-error>
                            <input :disabled="loading" id="hotel_address_zip" type="text" class="field" v-model="zip">
                        </div><!-- /.form__controls -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapFields} from 'vuex-map-fields';
    import InputError from './InputError';

    export default {
        name    : 'hotel-address',
        props   : [],
        data() {
            return {
                countries: []
            };
        },
        methods : {},
        computed: {
            ...mapFields([
                'order.hotel_address.name',
                'order.hotel_address.country',
                'order.hotel_address.zip',
                'order.hotel_address.street',
                'order.hotel_address.city',
                'order.requires_delivery',
                'loading',
            ]),
            isValid() {
                let valid = true;
                if(this.requires_delivery){
                    return this.city && this.zip && this.street && this.country && this.name;
                }
                return valid;
            },
        },
        created() {
            this.countries = window.countries ? window.countries : [];
        },
        components: {
            InputError
        }
    }
</script>

<style scoped>
    .form__controls input.field:disabled {
        cursor: default;
        background-color: #E9ECEF;
    }
</style>
